import axios from 'axios';
import { message } from 'antd';

const instance = axios.create({
    // 设置默认的请求baseURL
    baseURL: '/qiansheng',
    // 设置默认的请求超时时间
    timeout: 20000,
    // 设置默认的请求头
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});

// 请求拦截器
instance.interceptors.request.use(
    (config) => {
        // 在发送请求之前可以做一些处理，例如添加token等
        // config.headers['Authorization'] = 'Bearer ' + getToken();

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    (response) => {
        // 对响应数据进行处理，例如获取数据、错误处理等
        if (response.data.code != 200) {
            message.error(response.data.message || "操作失败！")
            return response.data
        }
        if (response.data.code == 401) {
            message.error(response.data.message);
            location.href = "/login"
            return
        }

        return response.data;
    },
    (error) => {
        // 处理请求错误，例如根据状态码进行不同的操作
        message.error(error.message || "请求错误");
        return Promise.reject(error);
    }
);

// 封装常用的请求方法
const request = {
    get: (url, params) => {
        return instance.get(url, { params });
    },
    post: (url, data) => {
        return instance.post(url, data);
    },
    put: (url, data) => {
        return instance.put(url, data);
    },
    delete: (url) => {
        return instance.delete(url);
    },
};

export default request;


// WEBPACK FOOTER //
// ./src/method/axios.js